<div class="grid" style="margin-top: 8px;">

  <div class="col-12 lg:col-12 flex flex-column">
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'model.devices' | transloco}}</h4></div>
      <hr>
      <div *ngIf="deviceMeasurements && deviceMeasurements.length > 0">
        <div class="p-datatable p-component">
          <p-table
            [(first)]="deviceMeasurementsFirst"
            [(rows)]="deviceMeasurementsRows"
            [value]="deviceMeasurements"
            [totalRecords]="totalDeviceMeasurements"
            [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
            [paginator]="true"
            [lazy]="true"
            (onLazyLoad)="loadDeviceMeasurements($event)"
            styleClass="p-datatable-striped"
            sortField="name"
            #deviceMeasurementsTable
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="w-18rem" pSortableColumn="device.serialNumber">
                  {{'model.device' | transloco}}
                  <p-sortIcon field="device.serialNumber"></p-sortIcon>
                </th>
                <th class="w-18rem" pSortableColumn="name">
                  {{'model.sensor' | transloco}}
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="description">
                  {{'attribute.description' | transloco}}
                  <p-sortIcon field="description"></p-sortIcon>
                </th>
                <th pSortableColumn="measurementType.sensor">
                  {{'model.sensorType' | transloco}}
                  <p-sortIcon field="measurementType.sensor"></p-sortIcon>
                </th>
                <th pSortableColumn="dateLastValueReported">
                  {{'attribute.dateLastValueReported' | transloco}}
                  <p-sortIcon field="dateLastValueReported"></p-sortIcon>
                </th>
                <th pSortableColumn="lastValueReported">
                  {{'attribute.lastValueReported' | transloco}}
                  <p-sortIcon field="lastValueReported"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-measurement>
              <tr *ngIf="!loadingDeviceMeasurements" class="fadein">
                <td>
                  <span class="p-column-title bold">{{'model.device' | transloco}}</span>
                  {{measurement.device.serialNumber}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
                  <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                  {{measurement.description}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
                  {{measurement.measurementType?.sensor ?? ''}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
                  <p class="text-right md:text-left">{{measurement.dateLastValueReported | customDate}}</p>
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.lastValueReported' | transloco}}</span>
                  {{measurement.lastValueReported}}
                </td>
              </tr>
              <tr *ngIf="loadingDeviceMeasurements"
                  class="fadein animation-delay-200 animation-fill-forwards no-opacity">
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between" *ngIf="totalDeviceMeasurements > 0">
                {{'pagination.showing' | transloco}} {{deviceMeasurementsFirst + 1}}
                {{'pagination.to' | transloco}} {{(deviceMeasurementsFirst + deviceMeasurementsRows) >= totalDeviceMeasurements ? totalDeviceMeasurements : (deviceMeasurementsFirst + deviceMeasurementsRows)}}
                {{'pagination.of' | transloco}} {{totalDeviceMeasurements}}
                {{(totalDeviceMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="flex justify-content-center mt-5 mb-4" *ngIf="deviceMeasurements && deviceMeasurements.length == 0">
        <p class="text-xl text-center p-2 font-italic">{{'empty.devices' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-12 flex flex-column">
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'model.assets' | transloco}}</h4></div>
      <hr>
      <div *ngIf="assetMeasurements && assetMeasurements.length > 0">
        <div class="p-datatable p-component">
          <p-table
            [(first)]="assetMeasurementsFirst"
            [(rows)]="assetMeasurementsRows"
            [value]="assetMeasurements"
            [totalRecords]="totalAssetMeasurements"
            [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
            [paginator]="true"
            [lazy]="true"
            (onLazyLoad)="loadAssetMeasurements($event)"
            styleClass="p-datatable-striped"
            sortField="name"
            #assetMeasurementsTable
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="w-18rem" pSortableColumn="asset.alias">
                  {{'model.asset' | transloco}}
                  <p-sortIcon field="asset.alias"></p-sortIcon>
                </th>
                <th class="w-18rem" pSortableColumn="name">
                  {{'model.sensor' | transloco}}
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="description">
                  {{'attribute.description' | transloco}}
                  <p-sortIcon field="description"></p-sortIcon>
                </th>
                <th pSortableColumn="measurementType.sensor">
                  {{'model.sensorType' | transloco}}
                  <p-sortIcon field="measurementType.sensor"></p-sortIcon>
                </th>
                <th pSortableColumn="dateLastValueReported">
                  {{'attribute.dateLastValueReported' | transloco}}
                  <p-sortIcon field="dateLastValueReported"></p-sortIcon>
                </th>
                <th pSortableColumn="lastValueReported">
                  {{'attribute.lastValueReported' | transloco}}
                  <p-sortIcon field="lastValueReported"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-measurement>
              <tr *ngIf="!loadingAssetMeasurements" class="fadein">
                <td>
                  <span class="p-column-title bold">{{'model.asset' | transloco}}</span>
                  {{measurement.asset.alias}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'model.sensor' | transloco}}</span>
                  <p class="text-right md:text-left" style="word-break: break-all;">{{measurement.name}}</p>
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                  {{measurement.description}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'model.sensorType' | transloco}}</span>
                  {{measurement.measurementType?.sensor ?? ''}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.dateLastValueReported' | transloco}}</span>
                  <p class="text-right md:text-left">{{measurement.dateLastValueReported | customDate}}</p>
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.lastValueReported' | transloco}}</span>
                  {{measurement.lastValueReported}}
                </td>
              </tr>
              <tr *ngIf="loadingAssetMeasurements"
                  class="fadein animation-delay-200 animation-fill-forwards no-opacity">
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between" *ngIf="totalAssetMeasurements > 0">
                {{'pagination.showing' | transloco}} {{assetMeasurementsFirst + 1}}
                {{'pagination.to' | transloco}} {{(assetMeasurementsFirst + assetMeasurementsRows) >= totalAssetMeasurements ? totalAssetMeasurements : (assetMeasurementsFirst + assetMeasurementsRows)}}
                {{'pagination.of' | transloco}} {{totalAssetMeasurements}}
                {{(totalAssetMeasurements > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="flex justify-content-center mt-5 mb-4" *ngIf="assetMeasurements && assetMeasurements.length == 0">
        <p class="text-xl text-center p-2 font-italic">{{'empty.assets' | transloco}}</p>
      </div>
    </div>
  </div>

  <div class="col-12 lg:col-12 flex flex-column">
    <div class="card">
      <div class="card-header pt-1"><h4 class="mb-1">{{'model.kpis' | transloco}}</h4></div>
      <hr>
      <div *ngIf="kpis && kpis.length > 0">
        <div class="p-datatable p-component">
          <p-table
            [(first)]="kpisFirst"
            [(rows)]="kpisRows"
            [value]="kpis"
            [totalRecords]="totalKpis"
            [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
            [paginator]="true"
            [lazy]="true"
            (onLazyLoad)="loadKpiMeasurements($event)"
            styleClass="p-datatable-striped"
            sortField="name"
            #kpisTable
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="name">
                  {{'attribute.name' | transloco}}
                  <p-sortIcon field="name"></p-sortIcon>
                </th>
                <th pSortableColumn="description">
                  {{'attribute.description' | transloco}}
                  <p-sortIcon field="description"></p-sortIcon>
                </th>
                <th pSortableColumn="organization.name" *ngIf="'ROLE_ADMIN' | userHasRole: false">
                  {{'model.organization' | transloco}}
                  <p-sortIcon field="organization.name"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-kpiRow>
              <tr *ngIf="!loadingKpis" class="fadein">
                <td>
                  <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
                  <p class="text-right md:text-left">{{kpiRow.name}}</p>
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
                  <p class="text-right md:text-left">{{kpiRow.description}}</p>
                </td>
                <td *ngIf="'ROLE_ADMIN' | userHasRole: false">
                  <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
                  <p class="text-right md:text-left">{{kpiRow.organization?.name}}</p>
                </td>
              </tr>
              <tr *ngIf="loadingKpis" class="fadein animation-delay-200 animation-fill-forwards no-opacity">
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
                <td style="height: 38.78px;">
                  <p-skeleton height="1em"></p-skeleton>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between" *ngIf="totalKpis > 0">
                {{'pagination.showing' | transloco}} {{kpisFirst + 1}}
                {{'pagination.to' | transloco}} {{(kpisFirst + kpisRows) >= totalKpis ? totalKpis : (kpisFirst + kpisRows)}}
                {{'pagination.of' | transloco}} {{totalKpis}}
                {{(totalKpis > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="flex justify-content-center mt-5 mb-4" *ngIf="kpis && kpis.length == 0">
        <p class="text-xl text-center p-2 font-italic">{{'empty.kpis' | transloco}}</p>
      </div>
    </div>
  </div>

</div>




